import { useTranslation } from 'react-i18next';
import { useMatchNavigationItems } from './subNavigation/useMatchNavigationItems';
import { useMatchRoute } from './useMatchRoute';

export const useMatchNavigationItem = () => {
  const { t } = useTranslation('navigation');
  const matchRoute = useMatchRoute();

  return {
    id: 'matches',
    icon: 'MatchSoccer' as const,
    path: `${matchRoute}/dashboard`,
    label: t('crossPlatform.primary.matches'),
    subNav: useMatchNavigationItems(),
  };
};
